import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/module/carousel.css";

// import bg4 from "../../assets/images/img/bg-4.webp";

const slides = [
  {
    title: "Brand Discovery",
    desc: "We begin by exploring your brand’s story, values, audience, and competitors. This helps us understand what makes your business unique and how to visually express it.",
  },
  {
    title: "Creative Strategy",
    desc: "Based on our discovery, we define the brand’s personality, visual style, and messaging direction to ensure consistency across all platforms and materials.",
  },
  {
    title: "Visual Concept Development",
    desc: "We craft initial design ideas—logos, color palettes, typography, and mood boards—that capture the essence of your brand and set the tone for its visual identity.",
  },
  {
    title: "Design Execution",
    desc: "Once a concept is approved, we build a complete visual system—logos, business cards, social media assets, and more—that brings your brand to life across mediums.",
  },
  {
    title: "Review and Refinement",
    desc: "We share the designs with you, gather feedback, and make refinements to ensure every detail aligns with your vision and business goals.",
  },
  {
    title: "Final Delivery",
    desc: "After approval, we provide all final assets in ready-to-use formats along with brand guidelines to ensure consistent use in the future.",
  },
  {
    title: "Brand Support",
    desc: "As your brand evolves, we’re here to support you—offering updates, new designs, and help adapting visuals for future campaigns or platforms.",
  },
];

export default function DesignSlider() {
  useScrollReveal("slide-from-left");
  useScrollReveal("drop-from-top");
  useScrollReveal("slide-from-bottom");
  const settings = {
    dots: true, // Show dots
    infinite: false, // Do not loop infinitely
    speed: 500, // Slide animation speed
    slidesToShow: 3, // Show 3 slides at once
    slidesToScroll: 1, // Scroll one slide at a time
    swipeToSlide: true, // Allow drag/swipe
    arrows: false, // Show arrows
    responsive: [
      // Responsive settings for smaller screens
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="karuzela" className="section section__carousel">
      {/* <img
        className="container-bg image-background left slide-from-left"
        src={bg4}
        alt="container background"
        style={{ marginTop: "400px" }}
      /> */}
      <div className="container carousel">
        <h5 className="drop-from-top">step by step</h5>
        <div className="title flex drop-from-top">
          <h2 style={{ marginBottom: 30 }}>
            What does the Graphic Design & Branding process look like?
          </h2>
        </div>

        <div className="carousel-slider slick-initialized slick-slider slick-dotted slide-from-right">
          <div className="slick-list draggable">
            <Slider {...settings}>
              {slides.map((slide, index) => (
                <div key={index} className="card" style={{ padding: 10 }}>
                  <div className="card-element">
                    <h6 className="title">{slide.title}</h6>
                    <span className="desc mini">{slide.desc}</span>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
